import { BaseConnection } from "./connection";
import { IntellexusDateStructure } from "./intellexusDate";
import { Place } from "./place";
import { Team } from "./team";

export enum SystemTeamContributionTypes {
  TRANSLATORS = "translators",
  REVISORS_OF_TIBETAN_TRANSLATION = "revisors_of_tibetan_translation",
  EARLIEST_CHINESE_TRANSLATION = "earliest_chinese_translation",
  CHINESE_TRANSLATION_CLOSER_TO_TIBETAN_WORK = "chinese_translation_closer_to_tibetan_work",
  CHINESE_TRANSLATION_CLOSER_TO_INDIC_WORK = "chinese_translation_closer_to_indic_work",
}

export const SYSTEM_TEAM_CONTRIBUTION_TYPE_LABELS: Record<
  SystemTeamContributionTypes,
  string
> = {
  [SystemTeamContributionTypes.TRANSLATORS]: "Translators",
  [SystemTeamContributionTypes.REVISORS_OF_TIBETAN_TRANSLATION]:
    "Revisors of Tibetan Translation",
  [SystemTeamContributionTypes.EARLIEST_CHINESE_TRANSLATION]:
    "Earliest Chinese Translation",
  [SystemTeamContributionTypes.CHINESE_TRANSLATION_CLOSER_TO_TIBETAN_WORK]:
    "Chinese Translation Closer to Tibetan Work",
  [SystemTeamContributionTypes.CHINESE_TRANSLATION_CLOSER_TO_INDIC_WORK]:
    "Chinese Translation Closer to Indic Work",
};

export type RevisionItem = { revision?: string };

export type VersionTeamConnection = BaseConnection & {
  system_team_contribution_type: SystemTeamContributionTypes;
  system_language_type: Team["system_language_type"];
  name?: string;
  date: IntellexusDateStructure;
  place_id?: string | null;
  place_identification_status: string;
  revision?: RevisionItem[];
  title?: string;
  taisho_catalog_no?: string;
  source_language?: string;
  place: Place | null;
};
